// import { useState, useEffect } from "react";
// import { getSiteFootprintReport } from "../services/analyticsService";

// /**
//  * Fetch count-based Site Footprint report.
//  * @returns {{ data: object|null, loading: boolean, error: Error|null, refresh: Function }}
//  */
// export const useSiteFootprintReport = (tenantId, year, month) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!tenantId || year == null || month == null) {
//       setData(null);
//       setError(null);
//       setLoading(false);
//       return undefined;
//     }

//     let cancelled = false;
//     setLoading(true);
//     setError(null);

//     (async () => {
//       try {
//         const response = await getSiteFootprintReport(tenantId, year, month);
//         if (cancelled) return;
//         if (response?.success && response?.data) {
//           setData(response.data);
//         } else {
//           setData(null);
//           setError(new Error(response?.message || "Failed to load site footprint report"));
//         }
//       } catch (err) {
//         if (cancelled) return;
//         setData(null);
//         setError(err);
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [tenantId, year, month]);

//   const refresh = async () => {
//     if (!tenantId || year == null || month == null) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await getSiteFootprintReport(tenantId, year, month);
//       if (response?.success && response?.data) {
//         setData(response.data);
//       } else {
//         setData(null);
//         setError(new Error(response?.message || "Failed to load site footprint report"));
//       }
//     } catch (err) {
//       setData(null);
//       setError(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { data, loading, error, refresh };
// };






import { useState, useEffect } from "react";
import { getSiteFootprintReport } from "../services/analyticsService";

/**
 * Fetch count-based Site Footprint report (current data only).
 */
export const useSiteFootprintReport = (tenantId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tenantId) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const response = await getSiteFootprintReport(tenantId);

        if (cancelled) return;

        if (response?.success && response?.data) {
          setData(response.data);
        } else {
          setData(null);
          setError(
            new Error(response?.message || "Failed to load site footprint report")
          );
        }
      } catch (err) {
        if (cancelled) return;
        setData(null);
        setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [tenantId]);

  const refresh = async () => {
    if (!tenantId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await getSiteFootprintReport(tenantId);

      if (response?.success && response?.data) {
        setData(response.data);
      } else {
        setData(null);
        setError(
          new Error(response?.message || "Failed to load site footprint report")
        );
      }
    } catch (err) {
      setData(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, refresh };
};